import React from 'react';

import dayjs from '~/timeInit';

import { Checkbox, TableCell, TableRow } from '@mui/material';

import DateWidget from '~/components/Common/Elements/DateWidget';

import { type SurchargeDates, isValidSurchargeRange } from '../tabs/surcharges/previousSurcharges';
import { WEEKDAY_LABELS } from '../tabs/surcharges/surchargeGridsModel';
import type { SurchargePeriodFormValues } from '../tabs/surcharges/types';

export type SurchargeDatesChange = (key: string, dates: Partial<SurchargeDates>) => void;

type CopySurchargeDatesRowProps = {
  dates: SurchargeDates;
  onDatesChange: SurchargeDatesChange;
  period: SurchargePeriodFormValues;
  periodKey: string;
};

export default function CopySurchargeDatesRow({ dates, onDatesChange, period, periodKey }: CopySurchargeDatesRowProps) {
  const invalid = !dates.skipped && !isValidSurchargeRange(dates);

  function handleStartChange(startDate: string) {
    onDatesChange(periodKey, { startDate });
  }

  function handleEndChange(endDate: string) {
    onDatesChange(periodKey, { endDate });
  }

  function handleSkipChange(event: React.ChangeEvent<HTMLInputElement>) {
    onDatesChange(periodKey, { skipped: event.target.checked });
  }

  return (
    <TableRow>
      <TableCell>{period.name || 'No name'}</TableCell>
      <TableCell>
        {period.weekdays.length ? period.weekdays.map((weekday) => WEEKDAY_LABELS[weekday]).join(', ') : 'Every day'}
      </TableCell>
      <TableCell align="right">{period.sellAud}</TableCell>
      <TableCell sx={{ minWidth: 170 }}>
        <DateWidget
          disabled={dates.skipped}
          onChange={handleStartChange}
          slotProps={{ textField: { size: 'small', error: invalid } }}
          value={dates.startDate}
        />
      </TableCell>
      <TableCell sx={{ minWidth: 170 }}>
        <DateWidget
          disabled={dates.skipped}
          minDate={dates.startDate ? dayjs(dates.startDate) : undefined}
          onChange={handleEndChange}
          slotProps={{ textField: { size: 'small', error: invalid } }}
          value={dates.endDate}
        />
      </TableCell>
      <TableCell padding="checkbox">
        <Checkbox
          checked={dates.skipped}
          inputProps={{ 'aria-label': `Skip ${period.name}` }}
          onChange={handleSkipChange}
          size="small"
        />
      </TableCell>
    </TableRow>
  );
}
